export default "__VITE_ASSET__ae83850d__"